import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { navItemsByRole } from './NavItems';

import './styles.scss';

const getNav = (userRole, canCreateLicenses) => {
  const nav = navItemsByRole[userRole] || [];
  return nav.filter((el) => typeof el.checkAvailable === 'undefined' || el.checkAvailable(userRole, canCreateLicenses));
};

const CustomLink = (props) => {
  return (
    <NavLink className={`${props.className} ${props.active ? props.classNameActive : ''}`} to={props.to}>
      {props.children}
    </NavLink>
  );
};

class Nav extends Component {
  render() {
    const { userRole, canCurrentUserCreateLicenses } = this.props;

    const nav = getNav(userRole, canCurrentUserCreateLicenses);

    if (!nav.length) return null;
    return (
      <div className={userRole !== 'user' ? 'non-user-sidebar' : ''}>
        <>
          <MetisMenu
            content={nav}
            activeLinkFromLocation
            activeLinkTo={this.props.location.pathname}
            className="vertical-nav-menu"
            iconNamePrefix=""
            classNameItemActive="nav-link-active"
            classNameStateIcon="pe-7s-angle-down"
            LinkComponent={CustomLink}
          />
        </>
      </div>
    );
  }
}

const mapStateToProps = ({ UserRoles, Auth }) => ({
  userRole: UserRoles.userRole,
  canCurrentUserCreateLicenses: Auth.canCurrentUserCreateLicenses,
});

export default withTranslation()(connect(mapStateToProps, null)(withRouter(Nav)));
